import { MessageCircle } from "lucide-react";
import { DEFAULT_WA } from "../lib/site";

export default function WhatsAppFab() {
    return (
        <a
            href={DEFAULT_WA}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#1FA855] text-white shadow-lg shadow-[#1FA855]/30 transition-all duration-300 hover:-translate-y-1 hover:bg-[#178a45]"
        >
            <MessageCircle className="h-6 w-6" />
        </a>
    );
}
